import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ThumbsUp, Eye } from 'lucide-react';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

export default function AIContentCard({ content, onClick, onMarkHelpful, delay = 0 }) {
  const contentTypeLabels = {
    tip: 'Consejo',
    article: 'Artículo',
    fact: 'Dato',
    recipe_suggestion: 'Receta sugerida'
  };

  const contentTypeColors = {
    tip: 'bg-blue-100 text-blue-700',
    article: 'bg-purple-100 text-purple-700',
    fact: 'bg-green-100 text-green-700',
    recipe_suggestion: 'bg-amber-100 text-amber-700'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ delay }}
    >
      <Card 
        className="p-4 hover:shadow-lg transition-all cursor-pointer bg-gradient-to-br from-indigo-50 to-purple-50 border-indigo-200"
        onClick={onClick}
      >
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center flex-shrink-0">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 mb-2">
              <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${contentTypeColors[content.content_type]}`}>
                {contentTypeLabels[content.content_type]}
              </span>
              <span className="text-xs text-indigo-600 font-medium">Generado por IA</span>
            </div>
            
            <h3 className="font-semibold text-gray-900 mb-2">{content.title}</h3>
            <p className="text-sm text-gray-600 line-clamp-2 mb-3">{content.content}</p>
            
            <div className="flex items-center gap-4 text-xs text-gray-500">
              <div className="flex items-center gap-1">
                <Eye className="w-3 h-3" />
                <span>{content.view_count || 0}</span>
              </div>
              <button 
                onClick={(e) => {
                  e.stopPropagation();
                  onMarkHelpful();
                }}
                className="flex items-center gap-1 hover:text-indigo-600 transition-colors"
              >
                <ThumbsUp className="w-3 h-3" />
                <span>{content.helpful_count || 0} útiles</span>
              </button>
            </div>
            
            {content.tags && content.tags.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-3">
                {content.tags.slice(0, 3).map((tag, index) => (
                  <span key={index} className="px-2 py-0.5 bg-white/60 text-indigo-700 text-xs rounded-full">
                    {tag}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      </Card>
    </motion.div>
  );
}